"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ImageIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1 2.5A1.5 1.5 0 012.5 1h11A1.5 1.5 0 0115 2.5v11a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 011 13.5v-11zm10.037 4.677a.667.667 0 00-1.157.01l-1.766 3.138a.667.667 0 01-1.084.11l-1.6-1.843a.667.667 0 00-1.062.074L2.29 11.87a.667.667 0 00.559 1.029h10.368a.667.667 0 00.575-1.003l-2.755-4.72zM5.2 5.9a1.4 1.4 0 110-2.8 1.4 1.4 0 010 2.8z",
    clipRule: "evenodd"
  })))
});
ImageIcon.displayName = 'ImageIcon';
var _default = exports.default = ImageIcon;